import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import filters from './filters/index';
import titleMixin from './mixin/title_mixin';
import ToastPlugin from 'vue-toast-notification';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'primeicons/primeicons.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import vBlur from 'v-blur'
import * as Sentry from '@sentry/vue';
import 'font-awesome/css/font-awesome.min.css'

// import VueAwesomePaginate from 'vue-awesome-paginate';
// import 'vue-awesome-paginate/dist/style.css';

import '@/utils/fcm_bridge'

const app = createApp(App);
app.mixin(titleMixin);

app.component('FontAwesomeIcon', FontAwesomeIcon);

Sentry.init({
  app,
  dsn: "https://6de40dd8f8444523683e5e45ab80dbd8@o4509616207167488.ingest.us.sentry.io/4509616218701824",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

app
  // .use(VueAwesomePaginate)
  .use(ToastPlugin)
  .use(vBlur)
  .use(store)
  .use(router)
  .mount('#app');

app.config.globalProperties.$filters = filters;
